module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty":"There are no jobs with an address specified"}}')
  delete Component.options._Ctor
}
